import { createActions } from 'redux-actions';

export const { setUserNote, clearUserNote, setUserNotes, clearUserNotes } = createActions(
  'SET_USER_NOTE',
  'CLEAR_USER_NOTE',
  'SET_USER_NOTES',
  'CLEAR_USER_NOTES',
);
